// import * as process from "node:process";

export const webEnv: IWebEnv = {
  isProd: process.env.NODE_ENV === "production",
  siteUrl: process.env.NEXT_PUBLIC_SITE_URL as string,
  jwtSecret: process.env.NEXTAUTH_SECRET as string,
  metrics: {
    microsoftClarity: process.env.NEXT_PUBLIC_MICROSOFT_CLARITY as string,
    googleAnalytics: process.env.NEXT_PUBLIC_GOOGLE_ANALYICS as string,
  },
  api: {
    url: process.env.NEXT_PUBLIC_URL_SERVER as string,
    gqlUrl: process.env.NEXT_PUBLIC_URL_SERVER_GRAPHQL as string,
    serverGqlUrl: process.env.NEXT_PUBLIC_SSR_URL_SERVER_GRAPHQL as string,
  },
  recaptcha: {
    google: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string,
  },
};

export interface IWebEnv {
  isProd: boolean;
  metrics: {
    microsoftClarity: string;
    googleAnalytics: string;
  };
  api: {
    url: string;
    gqlUrl: string;
    serverGqlUrl: string;
  };
  jwtSecret: string;
  siteUrl: string;
  recaptcha: {
    google: string;
  };
}
